import React from 'react';
import { Title, Objective, GridContainer } from './Components';

export const Naming = props => (
  <>
    <GridContainer>
      <Title handleChange={props.handleChange} value={props.title} error={props.filledInError.title}/>
    </GridContainer>
    <GridContainer>
      <Objective handleChange={props.handleChange} value={props.objective} error={props.filledInError.objective}/>
    </GridContainer>
  </>
);
